module.exports = __webpack_public_path__ + "img/data-item3-1.6e511b8.png";